
import { FiBriefcase, FiUser } from 'react-icons/fi';
import { useRemarkSync } from 'react-remark';
import styled from 'styled-components';
import { Svg } from '@/components/styled';
import { Disk, Mask } from '@/public/img/icons';
import devices from '@/utilities/devices';

// #region STYLE
const UserCardContainer = styled.div<{ profileImage: string }>`
	align-items: flex-start;
	display: flex;
	padding: 2rem 0 3rem;

	.image-container {
		background-image: ${({ profileImage }) => `url(${profileImage})`};
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		flex-shrink: 0;
		min-height: 400px;
		min-width: 351px;
	}

	.details-container {
		display: flex;
		flex-direction: column;
		margin: 2.2rem 0 0 .2rem;
		width: 100%;

		.details-informations {
			display: flex;
			color: ${({ theme }) => theme.color.prune};
			font-weight: bold;
			> div {
				align-items: center;
				display: flex;
				padding-right: 1.5rem;
				svg {
					height: 20px;
					padding-right: .5rem;
					padding-bottom: .2rem;
					width: 24px;
				}
			}
		}

		.details-description {
			margin: 1.5rem 0;
		}

		.details-funFacts {
			color: ${({ theme }) => theme.color.prune};
			font-weight: bold;
			> div {
				align-items: flex-start;
				display: flex;
				padding-bottom: 1.25rem;
				svg {
					padding-right: .5rem;
				}
			}
		}
	}

	@media screen and (${devices.mobile}) {
		align-items: center;
		flex-direction: column;
		padding: .5rem 0;

		.details-container {
			margin: 0;

			.details-informations {
				justify-content: center;
			}
		}
	}

	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		align-items: center;
		flex-direction: column;
		padding: .5rem 0;

		.details-container {
			margin: 0;

			.details-informations {
				justify-content: center;
			}
		}
	}
`;
// #endregion

/**
 * Defines the available field of a user card.
 */
interface UserCardOwnProps {
	readonly favoriteMusic: string;
	readonly funFact: string;
	readonly userDescription: string;
	readonly userName: string;
	readonly userPosition: string;
	readonly userImage: string;
}

// #region COMPONENT
const UserCard = ({ userDescription, favoriteMusic, funFact, userName, userPosition, userImage }: UserCardOwnProps) => {

	const markdownContent = useRemarkSync(userDescription);

	return (
		<UserCardContainer profileImage={userImage}>
			<div className='image-container' />
			<div className='details-container'>
				<div className='details-informations'>
					<div>
						<FiUser /> {userName}
					</div>
					<div>
						<FiBriefcase /> {userPosition}
					</div>
				</div>
				<div className='details-description'>
					{markdownContent}
				</div>
				<div className='details-funFacts'>
					{funFact && (
						<div>
							<Svg path='prune'>
								<Mask />
							</Svg>
							<div> {funFact} </div>
						</div>
					)}
					<div>
						<Svg path='prune'>
							<Disk />
						</Svg>
						<div> {favoriteMusic} </div>
					</div>
				</div>
			</div>
		</UserCardContainer>
	);
};

export default UserCard;
// #endregion
